import ModuleLaunch from '@/components/module/ModuleLaunch.vue';
import HUBApi from '@/service/hub-api';
import HUBStore from '@/store';
import HUBLog from '@/utils/logger';
import HUBValidation from '@/utils/validation';

/**
 * launch related pages
 */

const launchRouter = {
  routes: [
    {
      /** Module launch page */ path: '/launch/md/:moduleIdInTopic',
      name: 'moduleLaunch',
      component: ModuleLaunch,
    },
  ],
};

launchRouter.routes.forEach((r) => {
  const route = r;
  route.props = true;
});

launchRouter.guard = async (to, from) => {
  // Not a luanch page
  // go to next guard
  if (!HUBValidation.validateRoute(to.name, launchRouter.routes)) {
    return;
  }

  const { moduleIdInTopic } = to.params;
  const results = {};

  results.learningType = await HUBApi.get(`/learning-types/module/${moduleIdInTopic}`);

  // Current learning is unavailable
  if (
    !results.learningType ||
    !results.learningType.records ||
    !results.learningType.records[0] ||
    results.learningType.records[0].learning_type_status !== 'available'
  ) {
    HUBLog.debug(`Back to: ${from.path}`);
    throw new Error('$Reject');
  }

  results.topicModule = await HUBApi.get(`/topic-modules/${moduleIdInTopic}`);

  if (!results.topicModule || !results.topicModule.records || !results.topicModule.records[0]) {
    HUBLog.debug(`Back to: ${from.path}`);
    throw new Error('$Reject');
  }

  HUBStore.commit('setHUBSettingItems', {
    currentFunction: {
      key: results.learningType.records[0].learning_type_key,
      name: results.learningType.records[0].name,
    },
    currentModule: results.topicModule.records[0],
    levelUp: {
      name: 'moduleList',
      params: { topicId: results.topicModule.records[0].topicId },
    },
  });

  HUBLog.debug(`Access: ${to.path}`);
  throw new Error();
};

export default launchRouter;
